import { clearPurchasesListState } from './purchasesListState';

export const setAuthToken = (token: string) =>
  localStorage.setItem('token', token);

export const getAuthToken = () => localStorage.getItem('token');

export const deleteAuthToken = () => {
  clearPurchasesListState();
  localStorage.removeItem('token');
  window.location.href = '/';
};
